import React, { useRef, useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiImagePlusOutline } from "@mdi/js";
import FsLightbox from "fslightbox-react";
import EditOverviewSummary from "./editOverviewSummary";
import { ACCEPTED_IMAGE_TYPES } from "./editItemFormConstants";

const EditCoverPage = React.forwardRef(
  (
    {
      profileImage,
      onSelectCoverPhotoFile,
      uploading,
      reportId,
      initialSummary,
      onToast,
    },
    ref
  ) => {
    const fileInputRef = useRef(null);
    const [lightboxToggler, setLightboxToggler] = useState(false);

    const handleChangeClick = () => {
      fileInputRef.current?.click();
    };

    const handleFileChange = (event) => {
      const file = event.target.files?.[0];
      if (file && onSelectCoverPhotoFile) {
        onSelectCoverPhotoFile(file);
      }
      event.target.value = "";
    };

    const handleViewClick = () => {
      setLightboxToggler((prev) => !prev);
    };

    return (
      <div className="edit-cover-page" id="inspection-overview">
        <div className="edit-overview-section">
          <div className="edit-cover-photo-wrapper" ref={ref}>
            {profileImage ? (
              <div className="edit-cover-photo edit-cover-photo-filled">
                <img src={profileImage} alt="Property" />
                <div className="edit-cover-photo-hover">
                  <Button
                    variant="light"
                    className="edit-cover-photo-action-btn"
                    onClick={handleChangeClick}
                    disabled={uploading}
                  >
                    {uploading ? (
                      <>
                        <Spinner animation="border" size="sm" /> Uploading...
                      </>
                    ) : (
                      "Change Cover Photo"
                    )}
                  </Button>
                  <Button
                    variant="light"
                    className="edit-cover-photo-action-btn"
                    onClick={handleViewClick}
                  >
                    View
                  </Button>
                </div>
              </div>
            ) : (
              <div className="edit-cover-photo">
                <div className="edit-cover-photo-empty">
                  <Button
                    variant="primary"
                    onClick={handleChangeClick}
                    className="edit-cover-photo-add-btn"
                    disabled={uploading}
                  >
                    {uploading ? (
                      <>
                        <Spinner animation="border" size="sm" /> Uploading...
                      </>
                    ) : (
                      <>
                        <Icon path={mdiImagePlusOutline} size={0.667} />
                        Add Cover Photo
                      </>
                    )}
                  </Button>
                </div>
              </div>
            )}
            <input
              ref={fileInputRef}
              type="file"
              accept={ACCEPTED_IMAGE_TYPES}
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
          </div>
          <div className="edit-overview-content">
            <EditOverviewSummary
              reportId={reportId}
              initialSummary={initialSummary}
              onToast={onToast}
            />
          </div>
        </div>

        <div className="edit-formal-notice">
          <p className="edit-formal-notice-title">
            Formal elements will be visible in the compiled report.
          </p>
          <div className="edit-formal-notice-body">
            <p>Post-compilation, Morph adds:</p>
            <ul>
              <li>Inspection Scope & Disclaimer (if active)</li>
              <li>Definitions & Glossary</li>
              <li>Challenge Summary</li>
              <li>Property Details</li>
            </ul>
          </div>
        </div>

        {profileImage && (
          <FsLightbox
            toggler={lightboxToggler}
            sources={[profileImage]}
            type="image"
          />
        )}
      </div>
    );
  }
);

EditCoverPage.displayName = "EditCoverPage";

export default EditCoverPage;
